
const digest = 'f061a6f52ac1a50ac8381f0eb3684b5e1566b77c4aecd9479fc411b5192fc070';
const classes = {"wrapper":"_wrapper_1evrg_1","content":"_content_1evrg_4","text":"_text_1evrg_9","name":"_name_1evrg_14","controls":"_controls_1evrg_17"};
const css = `._wrapper_1evrg_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_1evrg_1 ._content_1evrg_4 {
  background-color: #eaedf3;
  margin: -34px -24px 24px -24px;
  padding: 30px 24px;
}
._wrapper_1evrg_1 ._content_1evrg_4 ._text_1evrg_9 {
  color: #000000;
  font-weight: 400;
  font-size: 18px;
}
._wrapper_1evrg_1 ._content_1evrg_4 ._text_1evrg_9 ._name_1evrg_14 {
  font-weight: 500;
}
._wrapper_1evrg_1 ._controls_1evrg_17 {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  